// extracted by mini-css-extract-plugin
export default {"formContainer":"Editor_formContainer__rA0C+","legend":"Editor_legend__67HX2"};